import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Avatar from '@mui/material/Avatar';
import { FC } from 'react';
import { Typography } from '@mui/material';

const ResponsiveAppBar: FC = () => {
	return (
		<AppBar
			position="static"
			sx={{
				marginBottom: 2,
				backgroundColor: 'white',
				color: '#016193',
				zIndex: 1000,
				position: 'relative',
			}}
		>
			<Toolbar
				disableGutters
				sx={{
					margin: '0 15px',
					zIndex: 1000,
					'@media (min-width: 600px)': {
						minHeight: '56px',
					},
				}}
			>
				<Avatar
					alt="EAS GPSR Database"
					src="/img/EAS-logo-new.svg"
					sx={{ display: { xs: 'none', lg: 'flex' }, mr: 1, height: 42, width: 42 }}
				/>
				<Box sx={{ flexGrow: 1, display: { xs: 'none', lg: 'flex' }, alignItems: 'center' }}>
					<Typography
						variant="h6"
						component="div"
						sx={{ flexGrow: 1, display: { xs: 'none', lg: 'flex' }, fontWeight: 600 }}
					>
						GPSR Database
					</Typography>
				</Box>
				<Box
					sx={{
						display: { xs: 'flex', sm: 'flex', lg: 'none' },
						mr: 1,
						ml: 2,
						flexGrow: 1,
						alignItems: 'center',
						gap: 1,
					}}
				>
					<Avatar alt="DASHBOARD" src="/img/EAS-logo-new.svg" />
					<Typography
						variant="h6"
						component="div"
						sx={{ flexGrow: 1, fontWeight: 600, fontSize: 18 }}
					>
						GPSR Database
					</Typography>
				</Box>
			</Toolbar>
		</AppBar>
	);
};
export default ResponsiveAppBar;
